import { computed } from "vue"

export const cptRecords = (state) => {
  return computed(() => {
    return state
  })
}